module.exports = __webpack_public_path__ + "static/4-53e1b98f907bdfc9f1308b79f86b7cfd.jpg";